var map = {
	"./0.png": 381239,
	"./1.png": 238222,
	"./2.png": 110021,
	"./3.png": 96956,
	"./4.png": 280563,
	"./5.png": 125354,
	"./6.png": 74337,
	"./7.png": 106072,
	"./8.png": 873551,
	"./9.png": 834534,
	"./x.png": 146703
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 427838;